import produce from 'immer';

import {
	FETCH_APARTMENTS_PENDING,
	FETCH_APARTMENTS_FULFILLED,
	FETCH_APARTMENTS_FAILED,
	FETCH_NEWEST_APARTMENTS_PENDING,
	FETCH_NEWEST_APARTMENTS_FULFILLED,
	FETCH_NEWEST_APARTMENTS_FAILED,
	SET_FILTERED_APARTMENTS_FULFILLED
} from '../constants/apartments.actions';
import {
	CLEAR_ALL_FILTERS_FULFILLED
} from '../constants/filters.actions';
import { FETCH_PAGE_FULFILLED } from '../constants/page.actions';

const apartmentsReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case FETCH_PAGE_FULFILLED: {
				draft.loading = false;
				draft.error = false;
				break;
			}
			case FETCH_APARTMENTS_PENDING: {
				draft.loading = true;
				draft.error = false;
				break;
			}
			case FETCH_APARTMENTS_FULFILLED: {
				draft.apartments = action.payload.apartments;
				draft.filteredApartments = action.payload.apartments;
				draft.loading = false;
				draft.error = false;
				break;
			}
			case FETCH_APARTMENTS_FAILED: {
				draft.loading = false;
				draft.error = true;
				break;
			}
			case FETCH_NEWEST_APARTMENTS_PENDING: {
				draft.newestApartmentsLoading = true;
				draft.newestApartmentsError = false;
				break;
			}
			case FETCH_NEWEST_APARTMENTS_FULFILLED: {
				draft.newestApartments = action.payload.apartments;
				draft.newestApartmentsLoading = false;
				draft.newestApartmentsError = false;
				break;
			}
			case FETCH_NEWEST_APARTMENTS_FAILED: {
				draft.newestApartmentsLoading = false;
				draft.newestApartmentsError = true;
				break;
			}
			case SET_FILTERED_APARTMENTS_FULFILLED: {
				draft.filteredApartments = action.payload.apartments;
				break;
			}
			case CLEAR_ALL_FILTERS_FULFILLED: {
				draft.filteredApartments = produce(draft.apartments, () => { });
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		apartments: null,
		filteredApartments: null,
		loading: false,
		error: false,
		newestApartments: null,
		newestApartmentsLoading: false,
		newestApartmentsError: false
	}
);

export default apartmentsReducer;
